import {Form, Select} from 'antd'
import {useMemo} from 'react'

export default function UpsertContact({parameters, fieldName}) {
    const available = useMemo(() => {
        const props = parameters?.properties
        if (!props) return []
        const arr = Array.isArray(props)
            ? props
            : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
        return arr
            .filter(({ type }) => type === 'string')
            .map(({ name }) => ({ label: name, value: name }))
    }, [parameters])

    return (
        <>
            <Form.Item label={'Nome'} name={[fieldName, 'action', 'data', 'name']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Identidade'} name={[fieldName, 'action', 'data', 'identity']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Empresa'} name={[fieldName, 'action', 'data', 'company']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Cargo'} name={[fieldName, 'action', 'data', 'position']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Data de nascimento'} name={[fieldName, 'action', 'data', 'birthday']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Ano de nascimento'} name={[fieldName, 'action', 'data', 'birthYear']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Origem'} name={[fieldName, 'action', 'data', 'origin']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'E-mail'} name={[fieldName, 'action', 'data', 'email']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Telefone'} name={[fieldName, 'action', 'data', 'phone']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'CEP'} name={[fieldName, 'action', 'data', 'zipCode']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'País'} name={[fieldName, 'action', 'data', 'country']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Estado'} name={[fieldName, 'action', 'data', 'state']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Cidade'} name={[fieldName, 'action', 'data', 'city']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Bairro'} name={[fieldName, 'action', 'data', 'district']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Rua'} name={[fieldName, 'action', 'data', 'street']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Número'} name={[fieldName, 'action', 'data', 'number']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
            <Form.Item label={'Complemento'} name={[fieldName, 'action', 'data', 'complement']}>
                <Select placeholder={'Selecione um parametro'} options={available}/>
            </Form.Item>
        </>
    )
}
